import { Button, Flex, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useNotifyPollAttendees } from "../../api/polls";

const NotifyAttendeesModal = ({ sessionId, onNotified }) => {
  const { mutate, isPending } = useNotifyPollAttendees(sessionId);

  return (
    <Flex direction="column" gap="md">
      <Text size="sm">
        Polls are now shown on the mobile homepage. Do you want to send a
        notification to the attendees?
      </Text>

      <Group gap="xs">
        <Button
          loading={isPending}
          onClick={() =>
            mutate(
              {},
              {
                onSuccess: () => {
                  onNotified();
                  modals.closeAll();
                },
              }
            )
          }
        >
          Notify attendees
        </Button>
        <Button variant="default" onClick={() => modals.closeAll()}>
          Not now
        </Button>
      </Group>
    </Flex>
  );
};

export const openNotifyAttendeesModal = (sessionId, onNotified) => {
  modals.open({
    title: "Notify attendees",
    children: (
      <NotifyAttendeesModal sessionId={sessionId} onNotified={onNotified} />
    ),
  });
};
